import React from "react";

const SubMenuItemBubble = React.memo(({ messageText, messageID, onClick }) => {
  return (
    <div>
      <div className="menuItemBubble" onClick={onClick}>
         {messageText}
      </div>
    </div>
  );
})

export default SubMenuItemBubble;
